interface FlashcardContentProps {
  children: React.ReactNode
}

export default function FlashcardContent({ children }: FlashcardContentProps) {
  return <div className="flex w-full justify-center">{children}</div>
}
